import { Chakra } from "@airhelp/react-ui-components";
import Content from "./Content";

const { Flex, Box } = Chakra;

const PressLogos = () => (
  <Box p={5} bgGradient="linear(to-b, #ffffff 50%, greyscale.300 0)">
    <Flex
      bg="white"
      justify="center"
      align="center"
      flexWrap="wrap"
      maxW="1202px"
      rounded={{ base: "sm", md: "lg" }}
      boxShadow="alt"
      mx="auto"
      p={6}
    >
      <Content textColor="primary.900" />
    </Flex>
  </Box>
);

export default PressLogos;
